import {atom} from "recoil";
import {
    ExcessGroupCreation,
    ExcessGroupEntityResponse,
    ExcessGroupSelectFE,
    FormSearchExcessGroupModel
} from "../api/types/excessGroup";
import {BASE_DEFINITION_FORM_STEPS} from "../constants";

export const excessGroupSelectListAtom = atom<ExcessGroupSelectFE[]>({
    key: "excessGroupSelectListAtom",
    default: []
});

export const initialExcessGroupFilters: FormSearchExcessGroupModel = {
    name: "",
    commercialCategoryId: null,
    commercialSegmentId: null,
    validityDateFrom: "",
    validityDateTo: "",
    dealers: [],
    legalEntities: []

};
export const excessGroupFiltersAtom = atom<FormSearchExcessGroupModel>({
    key: "excessGroupFiltersAtom",
    default: initialExcessGroupFilters
});

export const initialExcessGroupCreation: ExcessGroupCreation = {
    step: BASE_DEFINITION_FORM_STEPS.DEFINITION,
    readOnly: true,
    inUse: false,
    completed: [false, false, false]
};
export const excessGroupCreationAtom = atom({
    key: "excessGroupCreationAtom",
    default: initialExcessGroupCreation
});

export const excessGroupAtom = atom<ExcessGroupEntityResponse | null>({
    key: "excessGroupAtom",
    default: null
});
